import SUMMARY_EMPTY from "@/assets/summary/summary_empty.svg";
import GenerateButton from "./GenerateButton";
import usePermission from '@/sections/Summary/usePermission';

interface EmptyPanelProps {
  onSummaryClick?: () => void;
}

export default function EmptyPanel({ onSummaryClick }: EmptyPanelProps) {
  const { isOwner, allowBackUp, showEdit } = usePermission();

  const handleSummaryClick = () => {
    onSummaryClick?.();
  };

  return (
    <>
      <div className="flex flex-col flex-justify-center flex-items-center mt-36">
        <img src={SUMMARY_EMPTY} className="w-60 h-29.5 mb-6" />
        <span className="mt-1 text-center text-xs leading-5.5 text-mx-secondary font-normal opacity-30">
          轻松掌握关键信息，告别手动整理的繁琐与低效，
          <br />
          为工作和学习节省更多宝贵时间
        </span>
        <GenerateButton isPrevent={(!isOwner && allowBackUp) || !showEdit} preventText="创建副本后可使用该功能" onSummaryClick={handleSummaryClick} />
      </div>
    </>
  );
}
